import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=3a106e8f"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
import style0 from "./Upload.vue?vue&type=style&index=0&id=3a106e8f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a106e8f')) {
      api.createRecord('3a106e8f', component.options)
    } else {
      api.reload('3a106e8f', component.options)
    }
    module.hot.accept("./Upload.vue?vue&type=template&id=3a106e8f", function () {
      api.rerender('3a106e8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/Upload.vue"
export default component.exports